import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export function NotFound(): ReactElement {
	const { t } = useTranslation();

	return (
		<div className="flex h-full w-full items-center justify-center">
			<div className="text-center">
				<h1 className="text-2xl font-bold">{t('NotFound.Title')}</h1>
				<p className="mt-2 text-muted-foreground">{t('NotFound.Description')}</p>
			</div>
		</div>
	);
}
